import { render } from "./CreateWifiAP.vue?vue&type=template&id=39ebb8a6"
import script from "./CreateWifiAP.vue?vue&type=script&lang=ts"
export * from "./CreateWifiAP.vue?vue&type=script&lang=ts"
script.render = render

export default script